import { render, staticRenderFns } from "./EditContentPhotoComponent.vue?vue&type=template&id=6c203f73&scoped=true"
import script from "./EditContentPhotoComponent.vue?vue&type=script&lang=js"
export * from "./EditContentPhotoComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c203f73",
  null
  
)

export default component.exports